export default "__VITE_ASSET__CU1$WTf0__"